import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../../utils/animations';
import Section from './Section';
import Button from './Button';
import GradientText from './GradientText';

const CTASection = ({ title, description, buttonText, buttonLink, className = '' }) => {
  return (
    <Section background="dark" className={className}>
      <motion.div
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
        className="text-center max-w-3xl mx-auto"
      >
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
          {title}
        </h2>
        <p className="text-lg md:text-xl text-gray-300 mb-8">{description}</p>
        <Button variant="outline" size="lg" onClick={() => (window.location.href = buttonLink)}>
          {buttonText}
        </Button>
      </motion.div>
    </Section>
  );
};

export default CTASection;
